module.exports = __webpack_public_path__ + "img/Jody Avirgan.fe338a12.png";